// Generated by `pnpm ops:deploy`. Do not edit.
//
// Rewritten from the modules selected for this deployment. An unselected
// module is not imported here, which is what keeps it out of the bundle
// entirely rather than merely switched off inside it.

import type { BundledModule } from './registry-types';

export const BUNDLED: readonly BundledModule[] = [];
